var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.875 1.875V28.125H28.125V1.875H1.875ZM16.1606 22.3472C16.1606 24.9019 14.6606 26.0681 12.4753 26.0681C10.5009 26.0681 9.35813 25.0491 8.77219 23.8125L10.7822 22.5994C11.1694 23.2847 11.5209 23.865 12.3703 23.865C13.1784 23.865 13.6941 23.5481 13.6941 22.3125V13.9275H16.1606V22.3472ZM21.9956 26.0681C19.7044 26.0681 18.2222 24.9788 17.5012 23.5481L19.5112 22.3884C20.0391 23.25 20.73 23.8884 21.9431 23.8884C22.9622 23.8884 23.6194 23.3784 23.6194 22.6697C23.6194 21.8259 22.9509 21.5269 21.8203 21.0291L21.2053 20.7656C19.4241 20.01 18.2466 19.0547 18.2466 17.0447C18.2466 15.1931 19.6584 13.7869 21.8559 13.7869C23.4263 13.7869 24.5513 14.3316 25.3603 15.7613L23.4384 16.9922C23.0166 16.2366 22.5591 15.9375 21.8503 15.9375C21.1303 15.9375 20.6728 16.395 20.6728 16.9922C20.6728 17.7309 21.1303 18.0291 22.1906 18.4922L22.8056 18.7556C24.9037 19.6519 26.0812 20.5725 26.0812 22.6341C26.0812 24.8494 24.3347 26.0672 21.9966 26.0672L21.9956 26.0681Z",
    fill: "#606060"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJs);
export default __webpack_public_path__ + "static/media/js.44a6f8e57ccb1b535e4f770fc28cb888.svg";
export { ForwardRef as ReactComponent };